import { ReactComponent as SandClockIcon } from '@Icons/additional/sandclock.svg';
import styles from './request-header.module.css';

const RequestHeaderDetailsSection: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.iconWrapper}>
          <SandClockIcon />
        </div>
        <div className={styles.textSection}>
          <span className={styles.caption}>
            Awaiting Request Header Details
          </span>
        </div>
      </div>
    </div>
  );
};

export default RequestHeaderDetailsSection;
